import * as Yup from "yup";

export const initialValues = {
  FirstName: "",
  LastName: "",
  Email: "",
  DriverId: "",
  CarrierId: "",
};

export const DriverRegistrationSchema = Yup.object().shape({
  // Required fields
  FirstName: Yup.string()
    .matches(
      /^[A-Za-z]{2,10}$/,
      "First Name must be 2-10 characters, alphabets only"
    )
    .label("First Name")
    .required(),
  LastName: Yup.string()
    .matches(
      /^[A-Za-z]{2,10}$/,
      "Last Name must be 2-10 characters, alphabets only"
    )
    .label("Last Name")
    .optional(),
  Email: Yup.string()
    .email("Invalid email address")
    .label("Email")
    .required("Email is required"),
  DriverId: Yup.string()
    .matches(
      /^[A-Za-z0-9_-]{2,20}$/,
      "Driver Id must be 2-20 characters, alphabets, numbers, _ or - only"
    )
    .required("Driver Id is required"),
  CarrierId: Yup.string().label("Carrier Id").required(),
});

export const AdminRegistrationSchema = Yup.object().shape({
  // Required fields
  FirstName: Yup.string()
    .matches(
      /^[A-Za-z]{2,10}$/,
      "First Name must be 2-10 characters, alphabets only"
    )
    .label("First Name")
    .required(),
  LastName: Yup.string()
    .matches(
      /^[A-Za-z]{2,10}$/,
      "Last Name must be 2-10 characters, alphabets only"
    )
    .label("Last Name")
    .optional(),
  Email: Yup.string()
    .email("Invalid email address")
    .label("Email")
    .required("Email is required"),
  CarrierId: Yup.string().label("Carrier Id").required(),
});
